import { Column } from "@/components/Column";

// Loose groups that sweep across the upper sky; each group is staggered so
// one is usually in flight.
const BAT_GROUPS = [
  {
    top: 10,
    delayS: 0,
    bats: [
      { x: 0, y: 0, size: 1.6 },
      { x: 2.4, y: 1.2, size: 1.2 },
      { x: 4.2, y: -0.6, size: 1.4 },
    ],
  },
  {
    top: 22,
    delayS: -6,
    bats: [
      { x: 0, y: 0, size: 1.3 },
      { x: 2, y: -1, size: 1 },
    ],
  },
  {
    top: 6,
    delayS: -11,
    bats: [
      { x: 0, y: 0, size: 1.1 },
      { x: 1.8, y: 0.9, size: 1.4 },
      { x: 3.8, y: 0.2, size: 1 },
      { x: 5.4, y: 1.4, size: 1.2 },
    ],
  },
];

export const PlayyardBats = () => {
  return (
    <>
      {BAT_GROUPS.map((group) => (
        <Column
          key={group.top}
          className="staffer-pet-yard-bat-fly pointer-events-none absolute left-0 z-[37]"
          style={{
            top: `${group.top.toString()}%`,
            animationDelay: `${group.delayS.toString()}s`,
          }}
        >
          {group.bats.map((bat) => (
            <svg
              key={`${bat.x.toString()}-${bat.y.toString()}`}
              className="staffer-pet-yard-bat-flap absolute"
              style={{
                left: `${bat.x.toString()}cqw`,
                top: `${bat.y.toString()}cqw`,
                width: `${bat.size.toString()}cqw`,
                animationDelay: `${(-bat.x / 10).toString()}s`,
              }}
              viewBox="0 0 24 12"
            >
              <path
                d="M12 4 L13 2 L14 4 Q18 1 24 3 Q20 5 20 9 Q17 6 14 8 L12 10 L10 8 Q7 6 4 9 Q4 5 0 3 Q6 1 10 4 L11 2Z"
                fill="#140f1c"
              />
            </svg>
          ))}
        </Column>
      ))}
    </>
  );
};
